<script>
    import { onMount } from "svelte";

    import { validator } from '../validation';
	import lookups from "../stores/lookupStore";

	import FormRow from "./FormRow.svelte";
	import FormColumn from "./FormColumn.svelte";
	import Input from "./Input.svelte";
	import Select from "./Select.svelte";
	import YesNoGroup from "./YesNoGroup.svelte";
	import CheckboxList from "./CheckboxList.svelte";

	export let index = 0;
	export let disabled = false;
	export let superFund;

	let fundWrapper;
	let selectedBenefits = [];
	let otherBenefitRequired = false;
	let superFundInitialised = false;

	const benetifOther = "DISFUND003A13"

	onMount(() => {
		if (superFund.Benefits) {
			selectedBenefits = superFund.Benefits.split(",");
			otherBenefitRequired =  selectedBenefits.indexOf(benetifOther) >= 0;
		} else {
			selectedBenefits = [];
		}
		superFundInitialised = true;
	});

	export const superFundValidator = {
		validate() {
			return $validator.validateAll(fundWrapper);
		}
	}

	$: {
		if (superFund && superFundInitialised) {
			superFund.Benefits = selectedBenefits.join(",");
			otherBenefitRequired =  selectedBenefits.indexOf(benetifOther) >= 0;
		}
	}

</script>

<div bind:this={fundWrapper}>
	{#if (superFund && superFundInitialised) }
		<h3>Details of Super Fund or Insurer</h3>

		<FormRow>
			<FormColumn cols="6">
				<Select
					required
					{disabled}
					id="fundName{index}"
					label="Name of Fund or Insurer"
					optionList={$lookups.SuperFundOptions}
					bind:value={superFund.FundName}
					bind:text={superFund.FundNameLabel}
				/>
			</FormColumn>
			{#if (superFund.FundNameLabel == "Other")}
			<FormColumn cols="6">
				<!--  TODO - Update to correct  value  -->
				<Input required="{superFund.FundNameLabel == 'Other'}"
					{disabled}
					id="fundNameOther{index}"
					label="If other, please provide below:"
					bind:value={superFund.FundNameOther}
					maxlength="50"
				/>
			</FormColumn>
			{/if}
		</FormRow>

		<FormRow>
			<FormColumn cols="6">
				<Input
					{disabled}
					id="policyNumber{index}"
					label="Member or Policy Number"
					bind:value={superFund.PolicyNumber}
					maxlength="50"
				/>
			</FormColumn>
		</FormRow>

		<FormRow>
			<FormColumn cols="12">
				<label for="benefits" class="isrequired">What benefit are you seeking under this fund or insurer?</label>
				<CheckboxList
					required
					{disabled}
					name="benefits{index}"
					options={$lookups.BenefitOptions}
					bind:selectedOptions={selectedBenefits}
					cols="6"
				/>
			</FormColumn>
		</FormRow>

		{#if otherBenefitRequired}
		<FormRow>
			<FormColumn cols="6">
				<!--  TODO - Update to correct  value  -->
				<Input
					required
					{disabled}
					id="benefitsOther{index}"
					label="If Other, please specify below"
					bind:value={superFund.BenefitsOther}
					maxlength="50"
				/>
			</FormColumn>
		</FormRow>
		{/if}

		<FormRow>
			<FormColumn cols="12">
				<YesNoGroup required {disabled}
					label="Have you already lodged a claim with this fund or insurer?"
					name="claimLodged{index}"
					bind:value="{superFund.ClaimLodged}" />
			</FormColumn>
		</FormRow>

	{/if}
</div>
